import type { FC } from 'react';

import { SkeletonWrapper, SkeletonAvatar, SkeletonText } from '@livechat/design-system-react-components';
import { useSelector } from 'react-redux';

import { getIsCopilotModalExpanded } from 'store/views/copilot/selectors';

import * as styles from './styles';

export const CopilotChatFeedSkeleton: FC = () => {
  const isExpanded = useSelector(getIsCopilotModalExpanded);

  if (!isExpanded) {
    return (
      <SkeletonWrapper animated className={styles.loaderItem}>
        <SkeletonText height={46} />
      </SkeletonWrapper>
    );
  }

  return (
    <div className={styles.loaderContainerExpanded}>
      <SkeletonWrapper vertical animated className={styles.loaderItemExpanded}>
        <SkeletonAvatar size={32} />
        <SkeletonText height={240} />
        <div className={styles.loaderEmptyPlaceholder}></div>
      </SkeletonWrapper>
    </div>
  );
};
